export enum LdAccountLimits {
  PROFILE_VIEWS_MIN = 0,
  PROFILE_VIEWS_MAX = 40,
  LIKES_MIN = 0,
  LIKES_MAX = 150,
  CONNECTION_REQUESTS_MIN = 0,
  CONNECTION_REQUESTS_MAX = 30,
  MESSAGES_MIN = 0,
  MESSAGES_MAX = 100,
  IN_MAIL_MIN = 0,
  IN_MAIL_MAX = 50,
  WITHDRAW_LIMIT_MIN = 0,
  WITHDRAW_LIMIT_MAX = 90,
}
